module.exports = __webpack_public_path__ + "img/full3-min.99ac50bf.png";